export default {"src":"/bnb/_next/static/media/mathwallet.7f9e994b.svg","height":20,"width":20};